module.exports = __webpack_public_path__ + "img/backstage.ff76c081.svg";